import Vue from 'vue'
import browserDetect from 'vue-browser-detect-plugin'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

if (!String.prototype.startsWith) {
  /* eslint-disable no-extend-native */
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function (search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0
      return this.substring(pos, pos + search.length) === search
    }
  })
  /* eslint-enable no-extend-native */
}

Vue.config.productionTip = false
Vue.use(browserDetect)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
